import { currenciesListData } from './data';

type CurrencyType = {
  value: string;
  label: string;
};

export type GetCurrenciesListReturnType = CurrencyType[];

export const getCurrenciesList = (): GetCurrenciesListReturnType => {
  return currenciesListData.map((currency) => ({
    value: currency.value,
    label: currency.label,
  }));
};
